"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import ShoppingProductCard from "../ShoppingProductCard";
import WearthatLoader from "../../Atoms/WearthatLoader";
import { sendGTMEvent } from "@next/third-parties/google";
import { showBackInStockBadge } from "../../utils/utils";
import { UK } from "../../../public/Constants/EnumConstants";
import { getWishListData } from "../../../lib/bigcommerce/restfull/apis/wishlistAPIS";
import useStore from "../../../lib/Store/useStore";
const TypographyMontserrat = dynamic(
    () => import("../../Atoms/TypographyMontserrat")
);

const ProductsListScrollAreaModified = ({ products, pageInfo }) => {
    const { authSession } = useStore();
    const [wishListProducts, setWishListProducts] = useState(null);
    const [callServerAction, setCallServerAction] = useState(false);
    const [productsList, setProductsList] = useState({
        loading: false,
        list: [...products],
        lastItemCursor: pageInfo?.endCursor,
        firstItemCursor: pageInfo?.startCursor,
        pageInfo: pageInfo,
        hasPreviousPage: pageInfo?.hasPreviousPage,
    });

    useEffect(() => {
        setProductsList((prev) => ({
            ...prev,
            pageInfo: pageInfo,
            list: [...products],
        }));
    }, []);

    useEffect(() => {
        const getWishListItems = async () => {
            const response = await getWishListData(
                authSession?.user?.customer_id
            );
            setWishListProducts(response);
        };
        if (authSession?.user?.customer_id) getWishListItems();
    }, [callServerAction, authSession]);

    return productsList?.list?.length === 0 &&
        productsList?.loading === false ? (
        <div className="flex flex-col text-center h-screen mt-4 sm:mt-12">
            <TypographyMontserrat
                customStyle={" text-xl sm:text-[28px] "}
                fontWeight={"bold"}
                text={"No Products Found"}
            />
        </div>
    ) : productsList?.list?.length !== 0 ? (
        <>
            <div className="mt-3 sm:mt-5 grid grid-cols-2 sm:grid-cols-4 gap-x-4 sm:gap-x-6 gap-y-5 sm:gap-y-10">
                {productsList?.list?.map((product, index) => {
                    const backInStockBadge = showBackInStockBadge(
                        product?.custom_fields
                    );
                    const totalStockOfVariants = product?.variants?.reduce(
                        (n, { stock }) => n + stock,
                        0
                    );
                    const videoUrl = product?.custom_fields?.["product_video"];
                    const productId = product?.id;

                    const isWishListItem = wishListProducts?.items?.some(
                        (item) => item?.product_id == productId
                    );

                    const itemId = wishListProducts?.items?.find(
                        (item) => item?.product_id == productId
                    );

                    return (
                        <ShoppingProductCard
                            customerId={session?.user?.customer_id}
                            key={index}
                            itemId={itemId?.id}
                            callServerAction={setCallServerAction}
                            isWishListItem={isWishListItem}
                            link={`${product?.custom_url?.url}`}
                            name={product?.name}
                            brandName={product?.brand?.name}
                            categories={product?.categories}
                            images={product?.images}
                            videoUrl={videoUrl}
                            price={product?.converted_price?.toString()}
                            currencyCode={product?.currency}
                            productId={product?.id}
                            onClick={() =>
                                sendGTMEvent({
                                    event: "PLPInteractions",
                                    interaction_type: "cardclicked",
                                    interaction_item: product?.name,
                                })
                            }
                            backInStockBadge={backInStockBadge}
                            totalStockOfVariants={totalStockOfVariants}
                            variants={product?.variants}
                            sizeStandard={
                                product?.availability_description || UK
                            }
                        />
                    );
                })}
            </div>
        </>
    ) : (
        <WearthatLoader />
    );
};

export default ProductsListScrollAreaModified;
